import { Dispatch, SetStateAction, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { ConfigurationHistoriqueDto } from 'lib_api/lib/api/gen';

import { FetchDataUnpagedFunctionWithoutSort } from 'components/WrappedComponents/Table/types';
import { useApi } from 'hooks/ApiStoreContext';
import { backAlertMessage } from 'hooks/utils/backAlertMessage';

export function useGetConfigurationHistorique(idCorrelation: string): {
  fetchData: FetchDataUnpagedFunctionWithoutSort<
    ConfigurationHistoriqueDto,
    string
  >;
  filter: string;
  setFilter: Dispatch<SetStateAction<string>>;
} {
  const controller = useApi().AdminFonctionnelControllerApi;
  const [filter, setFilter] = useState<string>(idCorrelation);

  const { data } = useQuery({
    queryKey: ['configurationHistorique', idCorrelation],
    queryFn: async () => {
      return await controller
        .getConfigurationHistoriqueUsingGET(idCorrelation)
        .catch((e: Response) => {
          void backAlertMessage(e);
          throw e;
        });
    },
  });

  return {
    fetchData: () => {
      const result = data || [];
      return {
        total: result.length,
        data: result,
      };
    },
    filter: filter,
    setFilter: setFilter,
  };
}
